import Decimal from 'decimal.js';

import {
  DispositiveProvisionDispositionKind,
  DispositiveProvisionTransferTaxKind,
} from '@/types/schema';

import {
  DispositiveProvisionsFormRecipient,
  DispositiveProvisionsTemplateSlotKind,
} from '../DispositiveProvisionsForm/DispositiveProvisionsForm.types';

export const BLANK_POUROVER_RECIPIENT: DispositiveProvisionsFormRecipient = {
  _templateSlotKind: DispositiveProvisionsTemplateSlotKind.Pourover,
  recipientId: '', // blank string instead of null to avoid MUI warning
  recipientKind: null,
  dispositionKind_ButtonGroup: DispositiveProvisionDispositionKind.Percentage,
  dispositionKind_Select: '',
  dispositionAmount: null,
  dispositionPercentage: new Decimal(100),
  notes: '',
  transferTaxKind: DispositiveProvisionTransferTaxKind.Pourover,
  _dispositiveProvisionId: null,
  assetGroupIds: [],
  assetStaticIds: [],
  insurancePolicyIds: [],
  ownershipStakeIds: [],
  dispositionAssetPercentage: null,
};

export const BLANK_DISCLAIMER_TRUST: DispositiveProvisionsFormRecipient = {
  _templateSlotKind: DispositiveProvisionsTemplateSlotKind.OutrightDisclaimer,
  recipientId: '', // blank string instead of null to avoid MUI warning
  recipientKind: null,
  dispositionAmount: null,
  dispositionPercentage: null,
  notes: '',
  _dispositiveProvisionId: null,
  assetGroupIds: [],
  assetStaticIds: [],
  insurancePolicyIds: [],
  ownershipStakeIds: [],
  dispositionAssetPercentage: null,
  transferTaxKind: DispositiveProvisionTransferTaxKind.SpouseCreditShelter,
  dispositionKind_ButtonGroup: 'other',
  dispositionKind_Select:
    DispositiveProvisionDispositionKind.RemainingLifetimeExclusionOfGrantor,
};
